declare function loadPyodide(cfg);

const _PREAMBLE_URL: string = "/Meta/py/snippet.py.inc";

function pyodide_stdout(s: string, stderr = false) {
  if (window["_current_output_dom"]) {
    const line = document.createElement("pre");
    line.style["white-space"] = "pre-wrap";
    if (stderr) {
      line.classList.add("stderr");
    }
    window["_current_output_dom"].appendChild(line);
    line.appendChild(document.createTextNode(s));
  } else {
    const type = stderr ? "stderr" : "stdout";
    console.log(`PYODIDE [${type}]:` + s);
  }
}

export async function activate_py_snippet() {
  if ($('.snippet_action[data-lang="py"]').length == 0) {
    return;
  }
  const script_p = Promise.resolve(
    $.getScript("https://cdn.jsdelivr.net/pyodide/v0.28.2/full/pyodide.js")
  );
  const pyodide_p = script_p.then((_) =>
    loadPyodide({
      indexURL: "https://cdn.jsdelivr.net/pyodide/v0.28.2/full/",
      stdout: (s: string) => pyodide_stdout(s, false),
      stderr: (s: string) => pyodide_stdout(s, true),
    })
  );
  const preamble_p = fetch("/Meta/py/snippet.py.inc").then(res => res.text())

  $('.snippet_action[data-lang="py"]').on("click", function () {
    if ($(this).data("state") == "running") {
      return;
    }
    $(this).html("Running...");
    $(this).data("state", "running");
    const parent = $(this).parents(".snippet");
    const code = (<HTMLTextAreaElement>parent.find(".snippet_code")[0]).value;
    const output_dom_orig = window["_current_output_dom"];

    const packages_attr = $(this).data("pkgs")
    let packages = [];
    if (packages_attr === undefined || packages_attr == "") {
      packages = [];
    } else {
      packages = packages_attr.split(",").map(x => x.trim());
    }

    Promise.all([pyodide_p, preamble_p]).then(([pyodide, preamble]) => {
      pyodide.loadPackage(packages).then((_) => {
        window["_current_output_dom"] = parent.find(".snippet_output")[0];
        window["_current_output_dom"].innerHTML = "";
        try {
          pyodide.runPython(preamble + "\n" + code);
        } catch (err) {
          pyodide_stdout(err.toString(), true);
        }
        window["_current_output_dom"] = output_dom_orig;
        $(this).html("Click to run ▶");
        $(this).data("state", "");
      });
    });
  });
  $('.snippet_action[data-lang="py"][data-autorun]').trigger("click");
}
